import { Component, inject, Inject, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { HeaderStateService } from '../../../../main/headers/services/header-state.service';
import { AssignmentScheduleStateService } from '../../services/assignment-schedule-state.service';

@Component({
    templateUrl: './open-assignment-schedules.component.html',
    styleUrl: './open-assignment-schedules.component.scss'
})
export class OpenAssignmentSchedulesComponent implements OnInit {

    protected assignmentScheduleStateService = inject(AssignmentScheduleStateService)

    constructor(private headerStateService: HeaderStateService, private translocoService: TranslocoService) {
        this.headerStateService.setDetailHeader(
            this.translocoService.translate('main.header.assignmentSchedulesTitle'),
            this.translocoService.translate('main.header.assignmentSchedulesDescription'),
            '/assignments'
        );
    }

    ngOnInit(): void {
        this.assignmentScheduleStateService.loadOpenAssignmentSchedules();
    }

}
